import * as constants from './actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    answerHistory: []
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.POLL_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.POLL_SUCCESS:
            return {
                ...state,
                results: payload.results.map(r => ({
                    ...r,
                    answerId: parseInt(r.answerId, 10)
                })),
                lastAnsweredPoll: {
                    answerId: payload.answerId,
                    actionIdentifier: payload.actionIdentifier,
                    questionText: payload.questionText
                },
                answerHistory: (state.answerHistory || []).concat([
                    {
                        actionIdentifier: payload.actionIdentifier,
                        answerId: payload.answerId,
                        results: payload.results.map(r => ({
                            ...r,
                            answerId: parseInt(r.answerId, 10)
                        })),
                        questionText: payload.questionText
                    }
                ]),
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                actionInitiated: false
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    questionText: payload.questionText,
                    answers: payload.answers,
                    actionIdentifier: payload.actionIdentifier,
                    noOfAnswers: payload.noOfAnswers
                }
            };
        default:
            return state;
    }
}
